module.exports = __webpack_public_path__ + "static/scientist12-ca98425c4426ae8d1f85a3a63421d6e1.jpg";